import vueRequest from "./vueAiRequest";
import appConfigs from "@/config.js";
import rsaConfig from "../rsaConfig.js";

let prefix = '/open-ai';

export default prefix
/* ai百宝箱  ai相关接口  start */

//获取课评模板接口
export const getClassModel = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/prompt/getPromptCfg`,
    params:params,
    apiCode: '20230926001',
    type: "POST",
    isUCode: false,
    isSendRsa:false
});


//生成课评  用新的接口
export const createClassReview = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/prompt/getPromptResult`,
    params:params,
    apiCode: '20230926002',
    type: "POST",
    isUCode: false,
    isSendRsa:false
});


//获取首页模板
export const getIndexModelList = (params) => vueRequest({
    // apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/fumodu/getHomePageFuModu`, //修改之前
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/fumodu/getHomePageFuModuByChnl`,
    params:params,
    apiCode: '202309250011',
    type: "POST",
    isUCode: false,
    isSendRsa:true
});


//获取功能示例模块信息
export const getAiFumoduExt = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/fumodu/getAiFumoduExt`,
    params:params,
    apiCode: '20230925003',
    type: "POST",
    isUCode: false,
    isSendRsa:false
});

//获取功能示例模块信息 换一组 结果
export const getPromptResultByFumodu = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/fumodu/getPromptResultByFumodu`,
    params:params,
    apiCode: '20230925004',
    type: "POST",
    isUCode: false,
    isSendRsa:false
});


/*  一级模板分类(20230918002)| 负责人：赵志龙 */
export const getModelTypeList = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/dict/modelType`,
    params,
    type: "POST",
    apiCode: "20230918002",
    isUcode: false,
    isSendRsa: false,
});


/*  二级分类 工具应用列表查询(20230918003)| 负责人：赵志龙 */
export const getFuModuList = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/dict/queryFuModu`,
    params,
    type: "POST",
    apiCode: "20230918003",
    isUcode: true,
    isSendRsa: true,
});


/*  获取使用记录列表(20231011003)| 负责人：赵志龙 */
export const getUseRecordList = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/stu/rcd/query`,
    params,
    type: "POST",
    apiCode: "20231011003",
    isUcode: true,
    isSendRsa: true,
});

/*  删除使用记录(20231011001)| 负责人：赵志龙 */
export const delUseRecord = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/stu/rcd/del`,
    params,
    type: "POST",
    apiCode: "20231011001",
    isUcode: true,
    isSendRsa: true,
});


/*  获取使用记录详情(20231011002)| 负责人：赵志龙 */
export const getUseRecordDetail = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/stu/rcd/get`,
    params,
    type: "POST",
    apiCode: "20231011002",
    isUcode: true,
    isSendRsa: true,
});



/*  获取学员列表(90001109)| 负责人：李金磊 */
export const getStudentList = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/account/myStuInfoList`,
    params,
    type: "POST",
    apiCode: "90001109",
    isUcode: true,
    isSendRsa: true,
});

/*  添加学员(90001107)| 负责人：李金磊 */
export const addStudent = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/account/saveStudentInfo`,
    params,
    type: "POST",
    apiCode: "90001107",
    isUcode: true,
    isSendRsa: true,
});

/*  获取学员ai使用记录 90001110  | 负责人：李金磊 */
export const getStudentRecord = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/account/stuAIRecordList`,
    params,
    type: "POST",
    apiCode: "90001110",
    isUcode: true,
    isSendRsa: true,
});

/*  用户反馈添加类目 20231007001  | 负责人：赵志龙 */
export const addTypeUser = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/fbck/add`,
    params,
    type: "POST",
    apiCode: "20231007001",
    isUcode: true,
    isSendRsa: true,
});

/*  开始使用卡点功能 20230926003  | 负责人：赵志龙 */
export const startUseLogin = (params) =>
vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/prompt/loginCtrl`,
    params,
    type: "POST",
    apiCode: "20230926003",
    isUcode: true,
    isSendRsa: true,
});


/* ai百宝箱  ai相关接口  end */

/* 以下接口是否使用未知*/






























/**
 * 获取初始参数（100055）
 * @param clientId
 * @returns {Promise<unknown>}
 */
export const getTraceAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/zpzOauthOauthClientDetails/trace`,
    params: {clientId: rsaConfig.clientId},
    type: "POST",
    apiCode: 100055
});

// 获取CODE(130002)
// const appCode = query['appCode']?query['appCode']:'';
export const getCodeAPI = ({appCode, redirectUri}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/authentication/getMpUserAuthUrl?appCode=${appCode}`,
    type: "get",
    apiCode: 130002,
    params: {
        redirectUri:redirectUri
    }
});

// 获取openid
// export const getMpOpenIdByCodeAPI = ({appCode, authCode}) => vueRequest({
//     apiUrl: `${appConfigs.urlWebHttp}${prefix}/authentication/getMpOpenIdByCode`,
//     params: {appCode, authCode},
//     type: "POST",
//     apiCode: '2022052001'
// });

export const getMpOpenIdByCodeAPI = ({appCode, authCode}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${scrmprefix}/appletAccount/getMpOpenIdByCode`,
    params: {appCode, authCode},
    apiCode: '90001025',
    type: "POST",
    isUCode: false,
    isSendRsa: false
});
export const logoutAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/app/logout`,
    params:params,
    apiCode: '20230728001',
    type: "POST",
    isUCode: true,
    isSendRsa: true
});
/**
 * 获取访问用户身份（60000512）
 * @param code
 * @param corpId
 * @returns {Promise<unknown>}
 */
export const getUserInfo3rdAPI = ({code, corpId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/wecom/tp/getUserInfo3rd`,
    params: {code, corpId},
    type: 'post',
    apiCode: 60000512
});
/**
 * 获取所有菜单及按钮信息（60000521） | 负责人：何刚
 * @returns {Promise<unknown>}
 */
export const getAllRoleMenuListAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/menu/getAllRoleMenuList`,
    params: {},
    type: 'post',
    apiCode: 60000521,
    isSendRsa: true, //请求参数是否加密
    isUcode: true
});
/**
 * 登录
 * @param params
 * @returns {Promise<unknown>}
 */
export const oauthTokenAPI = ({grant_type = 'password', password, username = rsaConfig.appCode, scope = 'all', auth_type = 'wecom', refresh_token, userId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/oauth/token`,
    params: {grant_type, password: '', username, scope, auth_type, refresh_token, userId},
    type: "POST",
    apiCode: 10000001,
    isSendRsa: true, //请求参数是否加密
    contentType: 'application/x-www-form-urlencoded' //请求头
});
/**
 * 当前登录用户扩展信息（607216001）
 * @param params
 * @returns {Promise<unknown>}
 */
export const getUserInfoExtendAPI = params => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/getUserInfoExtend`,
    params,
    type: "POST",
    apiCode: 607216001,
    isSendRsa: true, //请求参数是否加密
    isUcode: true
});
/**
 * 获取字典（90011001）
 * @param dictType      字典类型
 * @param parentId      父级编号
 * @returns {Promise<unknown>}
 */
export const getDictAPI = ({dictType, parentId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/sysDict/getDict`,
    params: {dictType, parentId},
    type: "POST",
    apiCode: 90011001,
    isSendRsa: true,
    isUcode: true
});
/**
 * 获取OPENID(130001)
 * @param code
 * @returns {Promise<unknown>}
 */
export const getOpenIdAPI = ({code}) => vueRequest({
    apiUrl: `/api/wechat/getOpenId`,
    type: "POST",
    apiCode: 130001,
    params: {code}
});
/**
 * 获取CODE(130002)
 * @param appId
 * @param redirectUri
 * @returns {Promise<unknown>}
 */
// export const getCodeAPI = ({appId, redirectUri}) => vueRequest({
//     apiUrl: `/api/wechat/getCode`,
//     type: "POST",
//     apiCode: 130002,
//     params: {appId, redirectUri}
// });
/**
 * 构造第三方应用oauth2链接(身份验证))
 * @returns {Promise<unknown>}
 */
export const getAppAuthorizeUrlAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/wecom/tp/getAppAuthorizeUrl`,
    type: "get",
    apiCode: 130002
});
/**
 * 获取企业的jsapi_ticket(60000503)
 * @returns {Promise<unknown>}
 */
export const getComTicketAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/wecom/getComTicket`,
    type: "post",
    apiCode: 60000503,
    isSendRsa: false,
    isUcode: true
});
/**
 * 获取访问签名(60000506)
 * @param url
 * @returns {Promise<unknown>}
 */
export const getSignatureMapAPI = ({url, corpId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/wecom/getSignatureMap`,
    params: {url, corpId},
    type: "get",
    apiCode: 60000506,
    isSendRsa: false,
    isUcode: true
});
/**
 * 查询企微用户信息（60000069）
 * @param userId            企微用户ID
 * @returns {Promise<unknown>}
 */
export const getWorkWeiXinUserInfoAPI = ({userId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/workbench/staff/getWorkWeiXinUserInfo`,
    params: {userId},
    type: "post",
    apiCode: 60000069,
    isSendRsa: true,
    isUcode: true
});
/**
 * 用户详情（100024）
 * @returns {Promise<unknown>}
 */
export const selectMemberDetailsAPI = ({userCode, clientId = rsaConfig.clientId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/zpzOauthUser/selectMemberDetails`,
    params: {userCode, clientId},
    type: "post",
    apiCode: 100024,
    isSendRsa: true,
    isUcode: true
});
/**
 * 单个文件上传（ApiCode：21500031）
 * @param params
 * @returns {Promise<unknown>}
 */
export const singleUploadAPI = params => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/file/singleUpload`,
    params,
    type: 'POST',
    apiCode: 21500031,
    isSendRsa: false,
    isUcode: true
});
// 以下为业务逻辑

/**
 * 获取商机意向 需求 居住距离等标签数据
 *
 */
export const getBusinessTag = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/customer/selectCusDict`,
    params: {},
    type: "POST",
    apiCode: '10032',
    isSendRsa: false, //请求参数是否加密
    isUcode: true,//是否需要登陆
});

/**
 * 获取跟进标记页面数据标签查询 | 负责人：王子群
 *
 */
export const getFollowUpTagList = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/customer/selectFollowUp`,

    type: "POST",
    apiCode: '900001122',//license 值
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});

/**
 * 获取商机列表数据
 *
 */
export const getBusinessList = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/customer/selectCustomerAll`,
    params: {
        stageCode: 1,
        sortCode: 1,
    },
    type: "POST",
    apiCode: '900001116',//license 值
    isSendRsa: false, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 侧边栏接口(900000300)
 * @param externalUserId    用户微信code
 * @param studentCode       学员code
 * @returns {Promise<unknown>}
 */
export const sidebarIndexAPI = ({externalUserId, studentCode}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/sidebar/index`,
    params: {externalUserId, studentCode},
    type: "POST",
    apiCode: '900000300',//license 值
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 欠费设置查询-90001031） | 负责人：李金磊
 * @returns {Promise<unknown>}
 */
export const getMerchantArrearsConfigAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/merchantGeneralConfig/getMerchantArrearsConfig`,
    params: {},
    type: "POST",
    apiCode: '90001031',//license 值
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});


/**
 * 发送短信验证码（100045)
 * @param phone
 * @returns {Promise<unknown>}
 */
export const sendMsgCode = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}/scrmapi/authentication/sendMsgCode`,
    type: "post",
    apiCode: 100045,
    params,
    isSendRsa: false, //请求参数是否加密
    isUcode: false//是否需要登陆
});


/**
 * 手机号验证码登陆
 * @param params
 * @returns {Promise<unknown>}
 */
export const mobileLogin = params => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/oauth/token`,
    params,
    type: "POST",
    apiCode: 10000001,
    isSendRsa: true, //请求参数是否加密
    isUcode: false,//是否需要登陆
    contentType: 'application/x-www-form-urlencoded' //请求头
});

///open-ai/ai/stu/rcd/copyStt
export const copySttAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/stu/rcd/copyStt`,
    params,
    type: "POST",
    apiCode: "20231011002",
    isUcode: true,
    isSendRsa: true,
});

//open-ai/appletAccount/getWxMpFollowFlag
export const getWxMpFollowFlagAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/appletAccount/getWxMpFollowFlag`,
    params,
    type: "POST",
    apiCode: "20230809004",
    isUcode: false,
    isSendRsa: true,
});
//访问数据统计(20231123001) |负责人:赵志龙
export const pageAcssSttAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/page/acss/stt`,
    params,
    type: "POST",
    apiCode: "20231123001",
    isUcode: false,
    isSendRsa: true,
});
//生成当前用户邀请链接(90001114) |负责人:赵志龙
export const invitedUrlAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/account/invitedUrl`,
    params: params,
    type: "POST",
    apiCode: "90001114",
    isUcode: false,
    isSendRsa: true,
});


//获取微信授权的凭据（100008） |负责人：何刚
export const appletAccountTicketAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/appletAccount/ticket`,
    params,
    type: "GET",
    apiCode: "100008",
    isUcode: false,
    isSendRsa: false,
});

//获取用户常用应用(20231010006) |负责人:赵志龙
export const getUserFumoduListAPI = (params) => vueRequest({
    // apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/getUserFumoduList`,
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/getUserFumoduListByChnl`,
    params: {...params},
    type: "POST",
    // apiCode: "20231010006",
    apiCode: "20231010008",
    isUcode: true,
    isSendRsa: true,
});
//编辑常用应用(20231010007) |负责人:赵志龙
export const updUserFumoduAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/updUserFumodu`,
    params,
    type: "POST",
    apiCode: "20231010007",
    isUcode: true,
    isSendRsa: true,
});

//进行中的热门活动(20230914001) |负责人:邢又强
export const actyIngListAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/tqb/popuActy/actyIngList`,
    params,
    type: "POST",
    apiCode: "20230914001",
    isUcode: true,
    isSendRsa: false,
});
//进行中的案例(20230914002) |负责人:赵志龙
export const actyIngListCaseAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/tqb/popuActy/actyIngListCase`,
    params,
    type: "POST",
    apiCode: "20230914002",
    isUcode: true,
    isSendRsa: false,
});

//专区列表(20231207001) |负责人:赵志龙
export const zoneListAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/special/zone/zoneList`,
    params,
    type: "POST",
    apiCode: "20231207001",
    isUcode: false,
    isSendRsa: true,
});
//专区工具列表(20231207002) |负责人:赵志龙
export const zoneFumoduListAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/special/zone/zoneFumoduList`,
    params,
    type: "POST",
    apiCode: "20231207002",
    isUcode: false,
    isSendRsa: true,
});

//奖励明细(20231212001) |负责人:赵志龙
export const rewordDetailsAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/reword/rewordDetails`,
    params,
    type: "POST",
    apiCode: "20231212001",
    isUcode: true,
    isSendRsa: true,
});
//奖励统计(20231212002) |负责人:赵志龙
export const rewordTotalMoneyAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/reword/rewordTotalMoney`,
    params,
    type: "POST",
    apiCode: "20231212002",
    isUcode: true,
    isSendRsa: true,
});

//h5获取频道名称
export const getChnlNameAPI = (params) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/fumodu/getChnlName`,
    params,
    type: "POST",
    apiCode: "20231212003",
    isUcode: true,
    isSendRsa: true,
});



// WEBPACK FOOTER //
// ./src/modle/api.js